import { useQuery } from 'react-query'
import { EntityResolver } from 'services/entity-resolver'
import { ResolverResult } from 'interfaces/entity-resolver'

const resolveEntity = async (entityName: string): Promise<ResolverResult> => {
  return EntityResolver.resolve(entityName)
}

export const useEntityResolver = (entityName?: string) => {
  return useQuery(
    ['entity-resolver', entityName],
    () => resolveEntity(entityName!),
    {
      enabled: !!entityName && entityName.length > 0,
      staleTime: 60000, // Cache for 1 minute
      retry: 2,
      retryDelay: 1000,
    }
  )
}
